const sliderItems = {
  'sliderItems-1-title-a': 'Als mobile Glacé-Ape am Rhein',
  'sliderItems-1-title-b': 'und als Gelateria im Westfeld in Basel',
  'sliderItems-2-title': 'Über uns',
  'sliderItems-3-title': 'Unser Angebot',
  'sliderItems-4-title': 'Catering'
};

export default sliderItems;
